import React from 'react';
import './Easymaintenance.css';

const Easymaintenance = () => {
  const points = [
    {
      title: 'Easy Maintenance',
      description: 'Our movable platen lock mold system is designed for ease of maintenance.',
    },
    {
      title: 'High Precision & Stability',
      description: 'Our advanced double-platen structure ensures unmatched precision and stability.',
    },
    {
      title: 'Customized Solutions',
      description: 'Tailored solutions for different pallet sizes ensure optimal molding outcomes.',
    },
  ];

  return (
    <div className="why-choose-container">
      <h2 className="why-choose-title">Why Choose Powerjet</h2>
      <div className="why-choose-cards" data-aos="fade-down">
        {points.map((point, index) => (
          <div key={index} className="why-choose-card">
            <h3>{point.title}</h3>
            <p>{point.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Easymaintenance;
